import { emptyChecklistItemHelper } from '@/utils';
import { titles } from '@/services/checks/material.checks';

const TRANSITION_DELAY = 800;

export default (context: any) => ({
  [titles.BASIC_NAME]() {
    // focus on field
    context.selectPanel('info');
    setTimeout(() => {
      context
        .$el
        .querySelector('.field-name input')
        .focus();
    }, TRANSITION_DELAY);
  },
  [titles.BASIC_PHYSICAL]() {
    // focus on field
    context.selectPanel('info');
    setTimeout(() => {
      context
        .$el
        .querySelector('.field-weight input')
        .focus();
    }, TRANSITION_DELAY);
  },
  [titles.IMAGERY]() {
    context.selectPanel('assets');
    setTimeout(() => {
      context
        .$refs
        .assetManager
        .$el
        .querySelector('.asset-manager-add')
        .click();
    }, TRANSITION_DELAY);
  },
  [titles.PRICING]: () => emptyChecklistItemHelper(context, 'prices'),
  [titles.PROPERTIES]: () => emptyChecklistItemHelper(context, 'properties'),
  [titles.VENDORS]() {
    context.selectPanel('vendors');
  },
  [titles.WASHING]() {
    context.selectPanel('washing');
  },
});
